<div class="row">

    <div class="col-12">

        <div class="card">

            <div class="card-header">
                <div class="title"> Создание спецификации</div>
                <div class="tools">
                    <button type="button" class="btn btn-light btn-sm btn-back"  (click)="backTo()">
                        <!-- <i class="bi bi-arrow-left-square"></i> -->
                        {{ 'BACK' | translate }}
                    </button>
                    <button type="button" class="btn btn-primary btn-sm  btn-create" (click)="onCreate()" [disabled]="form.invalid">
                        <!-- <i class="bi bi-save"></i> -->
                        {{ 'SAVE' | translate }}
                    </button>
                    <!-- <button type="button" class="btn btn-primary btn-sm" (click)="onCreate()" [disabled]="form.invalid">
                        <i class="bi bi-save"></i> Сохранить и скачать
                    </button> -->
                </div>
            </div>

            <div class="card-body">

                <form class="form" [formGroup]="form" autocomplete="off">

                    <div class="row">


                        <div class="col-12">
                                    <ff-input-lang label="Наименование спецификации"
                                        hint="Укажите название спецификации на всех языках"
                                        fieldId="name"
                                        fieldName="name"
                                        fieldType="text"
                                        [clearField]="ffInputLangParams.name.clearField"
                                        [required]="ffInputLangParams.name.required"
                                        [inputValue]="specificationName"
                                        (changeValue)="eventFnFF('name', $event.name)">
                                    </ff-input-lang>
                        </div>

                        <div class="col-12">

                                    <div *ngIf="!file" class="dragarea" appDnd (fileDropped)="onFileDropped($event)">

                                        <label class="drag-label" for="label"> Перетащите файл сюда</label>
                                        <label class="size-label" for="label"> Максимальный размер файла: 100 МБ</label>

                                        <ff-button-upload-files label="{{ 'UPLOAD_FILE' | translate }}"
                                            component="specifications" (uploadedFiles)="onUploadedFile($event)">
                                        </ff-button-upload-files>
                                    </div>

                        </div>


                        <div *ngIf="file" class="col-12" formArrayName="specifications">

                                    <div *ngFor="let item of form.get('specifications')['controls']; let i = index;">

                                        <div class="row" [formGroupName]="i">

                                            <!-- NAME -->
                                            <div class="col-4">
                                                <div class="form-group">
                                                    <label class="filter-label" for="attribute_id"> Наименование</label>
                                                    <input type="text"
                                                           class="form-control"
                                                           id="field"
                                                           formControlName="column_name">
                                                </div>
                                                <div *ngIf="errorMessages">
                                                    <div *ngFor="let item of errorMessages.type">
                                                        <div class="text-error" *ngIf="validation(['specifications', i, 'field'], item.type)">
                                                            {{ item.message | translate: item.options }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- <div class="col-2">
                                                <div class="form-group">
                                                    <label class="filter-label" for="attribute_id"> Формат</label>
                                                    <ng-select id="format" class="custom"
                                                        clearAllText="{{ 'CLEAR' | translate }}"
                                                        notFoundText="{{ 'NO_DATA' | translate }}" bindValue="id"
                                                        bindLabel="name" formControlName="format" [items]="formats"
                                                        appendTo="body" [selectOnTab]="true">
                                                        <ng-template ng-option-tmp let-item="item">
                                                            <div title="{{item.name}}">{{item.name}}</div>
                                                        </ng-template>
                                                    </ng-select>
                                                    <div *ngIf="errorMessages">
                                                        <div *ngFor="let item of errorMessages.type">
                                                            <div class="text-error" *ngIf="validation(['specifications', i, 'format'], item.format)">
                                                                {{ item.message | translate: item.options }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> -->
                                           
                                            <!-- TYPE -->
                                            <div class="col-2">
                                                <div class="form-group">
                                                    <label class="filter-label" for="attribute_id"> Тип</label>
                                                    <ng-select id="type" class="custom" clearAllText="{{ 'CLEAR' | translate }}"
                                                        notFoundText="{{ 'NO_DATA' | translate }}" bindValue="id"
                                                        bindLabel="name" 
                                                        formControlName="type" 
                                                        (change)="onListenerType(i)"
                                                        [items]="types" 
                                                        
                                                        [selectOnTab]="true">
                                                        <ng-template ng-option-tmp let-item="item">
                                                            <div title="{{item.name}}">{{item.name}}</div>
                                                        </ng-template>
                                                    </ng-select>
                                                    <div *ngIf="errorMessages">
                                                        <div *ngFor="let item of errorMessages.type">
                                                            <div class="text-error" *ngIf="validation(['specifications', i, 'type'], item.type)">
                                                                {{ item.message | translate: item.options }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- REQUIREMENT -->
                                            <div [ngClass]="{
                                            'col-3': form.get('specifications').value.length > 1 && !isFormula[i],
                                            'col-5': form.get('specifications').value.length > 1  && isFormula[i],
                                            'col-4': form.get('specifications').value.length == 1 && !isFormula[i],
                                            'col-6': form.get('specifications').value.length == 1 && isFormula[i]}">
                                                <div class="form-group">
                                                    <label class="filter-label" for="attribute_id"> Требование к содержанию</label>

                                                    <!-- <tag-input *ngIf="!isFormula[i]"
                                                    formControlName="requirement" 
                                                    [modelAsStrings]="true"
                                                    placeholder="{{ 'ADD_VALUE' | translate }}"
                                                    secondaryPlaceholder="{{ 'INTER_VALUE' | translate }}" 
                                                    addOnBlur="true"
                                                    addOnPaste="true">
                                                    </tag-input> -->

                                                    <ng-select 
                                                    *ngIf="!isFormula[i]"
                                                    id="action" 
                                                    class="custom" 
                                                    clearAllText="{{ 'CLEAR' | translate }}"
                                                    notFoundText="{{ 'NO_DATA' | translate }}" 
                                                    bindLabel="name"
                                                    formControlName="requirement"
                                                    (change)="onListenerAttribute(i)"
                                                    
                                                    [selectOnTab]="true"
                                                    [items]="attributes">
                                                        <ng-template ng-option-tmp let-item="item">
                                                            <div title="{{item.name}}">{{item.name}}</div>
                                                        </ng-template>
                                                    </ng-select>

                                                    <div *ngIf="errorMessages && !isFormula[i]">
                                                        <div *ngFor="let item of errorMessages.type">
                                                            <div class="text-error" *ngIf="validation(['specifications', i, 'requirement'], item.type)">
                                                                {{ item.message | translate: item.options }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div *ngIf="isFormula[i] && !formula[i]">
                                                        <button type="button" class="btn btn-primary btn-sm" (click)="onCreateFormula(i)">
                                                            <i class="bi bi-save"></i> Настроить формулу
                                                        </button>
                                                    </div>

                                                    <div class="formula-data" *ngIf="isFormula[i] && formula[i]">

                                                        <div class="formula-info" *ngFor="let item of formula[i]; let j = index">

                                                            / {{item.name}} 

                                                        </div>

                                                        <div class="remove-formula-field" *ngIf="formula[i].length > 1">

                                                            <!-- edit -->
                                                            <button type="button" class="btn btn-light" (click)="onEditFormula(i)"  ngbTooltip="Редактировать формулу" placement="bottom">
                                                                <i class="bi bi-pencil-square"></i>
                                                            </button>

                                                            <!-- delete -->
                                                            <button type="button" class="btn btn-light" (click)="removeFormulaField(i)"  ngbTooltip="Удалить формулу" placement="bottom">
                                                                <i class="bi bi-trash"></i>
                                                            </button>
                                                        </div>
                                                        
                                                    </div>
                                                    
                                                </div>
                                            </div>

                                            <!-- LANG -->
                                             <div class="col-2" *ngIf="!isFormula[i]">
                                                <div class="form-group">
                                                    <label class="filter-label" for="attribute_id"> Язык</label>
                                                    <ng-select 
                                                        id="lang" 
                                                        class="custom" 
                                                        clearAllText="{{ 'CLEAR' | translate }}"
                                                        notFoundText="{{ 'NO_DATA' | translate }}" 
                                                        bindValue="id"
                                                        bindLabel="name" 
                                                        formControlName="lang_code" 
                                                        [items]="langs" 
                                                        appendTo="body"
                                                        [readonly]="!readonly[i]"
                                                        [selectOnTab]="true">
                                                        <ng-template ng-option-tmp let-item="item">
                                                            <div title="{{item.name}}">{{item.name}}</div>
                                                        </ng-template>
                                                    </ng-select>
                                                    <!-- <div *ngIf="errorMessages">
                                                        <div *ngFor="let item of errorMessages.type">
                                                            <div class="text-error" *ngIf="validation(['specifications', i, 'lang_code'], item.lang_code)">
                                                                {{ item.message | translate: item.options }}
                                                            </div>
                                                        </div>
                                                    </div> -->
                                                </div>
                                            </div>

                                            <div class="col-1 remove-filter-field" *ngIf="form.get('specifications').value.length > 1">
                                                <button type="button" class="btn btn-danger" (click)="removeFilterField(i)">
                                                    <i class="bi bi-trash"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                        </div>

                    </div>

                </form>

                <div class="row">

                    <a *ngIf="file" class="col-2 add-field" for="add-field" (click)="addFilterFields()">
                        <i class="bi bi-plus-circle"></i>Добавить поле
                    </a>

                </div>
               
            </div>
        </div>
    </div>
</div>